import { selectAuthenticationInfo } from '@src/selectors/user';
// eslint-disable-next-line import/namespace
import { RoleType } from '@src/types';

import * as route from '@utils/adminRoutes';
import { useSelector } from 'react-redux';

const AuditorBlockedRoutes = [
  route.urlChannels,
  route.urlUser,
  route.urlBatchMessages,
  route.urlMyAccount,
  route.pathManageSubscription,
  route.pathIntegrations,
  route.pathChatsBehavior,
  route.urlSecuritySettings,
];
const AgentBlockedRoutes = [
  route.urlOrdersOrder,
  route.urlCreateOrder,
  route.urlOrderGeneralReport,
  route.urlOrderOrdersReport,
  route.urlOrderProductsReport,
  `${route.urlOrderDetail}/:orderNumber`,
  `${route.urlCreateProduct}/:productId`,
  route.urlCreateProduct,
  route.urlProductsOrder,
  route.urlAdminBuild,
  route.urlChannelFbAccount,
  route.urlChannelTelegramAccount,
  route.urlChannelLivechatAccount,
  route.urlChannelWppSetup,
  route.urlChannelWppTemplate,
  route.urlChannels,
  route.urlDepartments,
  route.urlFlowBuilder,
  route.urlMyReports,
  route.urlAnalyticsChatTags,
  route.urlSatisfactionConfiguration,
  route.urlMessagesSetup,
  route.urlMyAccount,
  route.urlCustomFields,
  route.pathQuickMessages,
  route.pathBusinessTime,
  route.pathAutomaticMessages,
  route.pathIntegrations,
  route.pathChatsBehavior,
  route.pathManageSubscription,
  route.urlUser,
  route.urlChatsManagement,
  route.urlBatchMessages,
  route.urlTagsConverManagement,
  route.urlTagsContactManagement,
  route.urlFaqsQA,
  route.urlFaqsSetup,
  route.urlAuditV2,
  route.pathGeneralsConfig,
  route.pathGeneralSettings,
  route.urlSecuritySettings,
];
const MarketingBlockedRoutes = [
  route.urlAnalyticsFaqs,
  route.urlAnalyticsCustomerSatisfactionBinary,
  route.urlAnalyticsCustomerSatisfactionStars,
  route.urlOrdersOrder,
  route.urlCreateOrder,
  route.urlOrderGeneralReport,
  route.urlOrderOrdersReport,
  route.urlOrderProductsReport,
  `${route.urlOrderDetail}/:orderNumber`,
  `${route.urlCreateProduct}/:productId`,
  route.urlCreateProduct,
  route.urlProductsOrder,
  route.urlAdminBuild,
  route.urlChannelFbAccount,
  route.urlChannelTelegramAccount,
  route.urlChannelLivechatAccount,
  route.urlDepartments,
  route.urlFlowBuilder,
  route.urlMyReports,
  route.urlFaqsSetup,
  route.urlFaqsQA,
  route.urlSatisfactionConfiguration,
  route.urlMessagesSetup,
  route.urlMyAccount,
  route.urlCustomFields,
  route.pathQuickMessages,
  route.pathBusinessTime,
  route.pathAutomaticMessages,
  route.pathIntegrations,
  route.pathChatsBehavior,
  route.pathManageSubscription,
  route.urlUser,
  route.urlChatsManagement,
  route.urlSecuritySettings,
];

const BlockedRoutes = {
  [RoleType.ADMIN]: [],
  [RoleType.AGENT]: AgentBlockedRoutes,
  [RoleType.MARKETING]: MarketingBlockedRoutes,
  [RoleType.AUDITOR]: AuditorBlockedRoutes,
};

export const MandatoryBlockedRoutes = {
  [RoleType.ADMIN]: [],
  [RoleType.AGENT]: [route.urlSecuritySettings],
  [RoleType.MARKETING]: [route.urlSecuritySettings],
  [RoleType.AUDITOR]: [route.urlSecuritySettings],
};
const useBlockedRoutesByRol = () => {
  const user = useSelector(selectAuthenticationInfo);

  return {
    blockedRoutes: (BlockedRoutes[user?.role as RoleType] || []) as string[],
    mandatoryBlockedRoutes: (MandatoryBlockedRoutes[user?.role as RoleType] ||
      []) as string[],
  };
};

export default useBlockedRoutesByRol;
